/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { VisualizationLabel } from '../models/VisualizationLabel';

/**
* The source storage backup status
*/
export class SourceStorageBackupStatus {
  'data'?: Array<VisualizationLabel>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "data",
      "baseName": "data",
      "type": "Array<VisualizationLabel>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SourceStorageBackupStatus.attributeTypeMap;
  }

  public constructor() {
  }
}

